export default __webpack_public_path__ + "static/media/notifications-blue.1cb0386f.svg";